export const checkPermission = (role, actions, permissionsData) => {
  const userType = localStorage.getItem("user_type");
  // console.log("permissionsData==>", userType);
  if (userType != "Admin") {
    if (!Array?.isArray(actions)) {
      actions = [actions];
    }

    return actions?.every((action) => permissionsData?.[role]?.[action]);
  } else {
    return true;
  }
};
